import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useGlobalStore } from './global';
export const useMainMenuStore = defineStore('main-menu', {
    getters: {
        mainMenuList() {
            const featureList = useFeatureListStore();
            const categoryList = featureList.data?.category_list;
            return categoryList?.map(({ name, code, sub_category_list }) => ({
                name,
                code,
                sub: sub_category_list.map((subCategory) => ({
                    code: subCategory.code,
                    name: subCategory.name,
                })),
            }));
        },
        /**
         * 当前分类下所对应的menu 文案
         */
        mainMenuTip() {
            const globalStore = useGlobalStore();
            const featureList = useFeatureListStore();
            const categoryList = featureList.data?.category_list;
            return categoryList?.[globalStore.flowStatus.currentStep[0]]
                ?.reference_desc;
        },
        /**
         * 总价值文案
         */
        valueText() {
            const globalStore = useGlobalStore();
            const featureList = useFeatureListStore();
            const categoryList = featureList.data?.category_list;
            return categoryList?.[globalStore.flowStatus.currentStep[0]]?.total_price;
        },
    },
});
